import z from "zod";

export const ChangeOwnerSchema = z.object({
  owner: z.object(
    {
      label: z.string().nullable().optional(),
      value: z.number(),
    },
    { message: "この項目は必須です。" }
  ),
});

export type ChangeOwnerFormData = z.infer<typeof ChangeOwnerSchema>;
